import { createTheme } from '@mui/material/styles';

/**
 * MUI 전역 테마 - Pretendard 폰트 고정
 * 모든 MUI 컴포넌트에 typography.fontFamily가 자동 적용됨
 * @see layout.tsx - pretendard.variable (--font-pretendard)
 */
export const muiTheme = createTheme({
  typography: {
    fontFamily: 'var(--font-pretendard), "Spoqa Han Sans Neo", sans-serif',
  },
});
